import { Spinner, SpinnerSize } from '@bechtel/gds';
import { map } from 'lodash';
import { Suspense, useState } from 'react';
import { ErrorBoundary } from '~/components';
import { TabAdminButtonStyled } from '~/styles';
import ManageUsers from '../users';
import { UserAdminTabList } from './data';
import { ManagePermission } from './manage-permission';
import { Roles } from './roles';
import { ProjectAdminContainerStyled, ProjectAdminTabStyled } from './styled';
import { UserAdminTab, UserAdminTabType } from './types';

export const UserAdmin = () => {
  const [selectedTab, setSelectedTab] = useState<UserAdminTabType>(UserAdminTabType.EDIT_USERS);
  return (
    <ErrorBoundary>
      <ProjectAdminContainerStyled>
        <ProjectAdminTabStyled>
          {map(UserAdminTabList, (tabItem: UserAdminTab) => {
            return (
              <TabAdminButtonStyled
                selected={tabItem.value === selectedTab}
                onClick={() => {
                  setSelectedTab(tabItem.value);
                }}
                key={tabItem.value}
              >
                {tabItem.label}
              </TabAdminButtonStyled>
            );
          })}
        </ProjectAdminTabStyled>
        {selectedTab == UserAdminTabType.EDIT_USERS && (
          <ErrorBoundary>
            <Suspense fallback={<Spinner size={SpinnerSize.LARGE} />}>
              <ManageUsers />
            </Suspense>
          </ErrorBoundary>
        )}
        {selectedTab == UserAdminTabType.CUSTOMIZE_ROLES && (
          <ErrorBoundary>
            <Suspense fallback={<Spinner size={SpinnerSize.LARGE} />}>
              <Roles />
            </Suspense>
          </ErrorBoundary>
        )}
        {selectedTab == UserAdminTabType.CHANGE_PERMISSIONS && (
          <ErrorBoundary>
            <Suspense fallback={<Spinner size={SpinnerSize.LARGE} />}>
              <ManagePermission />
            </Suspense>
          </ErrorBoundary>
        )}
      </ProjectAdminContainerStyled>
    </ErrorBoundary>
  );
};
